import { render, staticRenderFns } from "./SummaryList.vue?vue&type=template&id=af7faf48&scoped=true"
import script from "./SummaryList.vue?vue&type=script&lang=js"
export * from "./SummaryList.vue?vue&type=script&lang=js"
import style0 from "./SummaryList.vue?vue&type=style&index=0&id=af7faf48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af7faf48",
  null
  
)

export default component.exports